import { MDBCol, MDBBtn } from 'mdb-react-ui-kit';
import React from 'react'

const SectionLeftText = ({updateStoryData, title, description, img, intro, setShowStory}) => {
  return (
    <React.Fragment>
        <div className="d-flex flex-row">
            <MDBCol className="col-sm-12 col-md-6 d-flex flex-column justify-content-center align-items-center p-4 text-start">
                <h5 className="section-title text-white mb-3">{title}</h5>
                <p className="section-paragraphs-text mb-4">{intro}</p>
                <MDBBtn outline rounded color='light' className="main-button d-flex justify-content-center align-items-center px-2 py-1 w-50 align-self-start" onClick={() => {
                updateStoryData({title,description,img});
                setShowStory(true)}
                }>
                    <span className="section-button-text py-2">More</span>
                </MDBBtn>
            </MDBCol>
            <MDBCol className="col-sm-12 col-md-6 d-flex flex-column p-4">
                <img className="img-fluid section-image-small rounded" src={img} alt=""></img>
            </MDBCol>
        </div>
    </React.Fragment>
  )
}

export default SectionLeftText
